import RequestManager from "./RequestManager";

const resetPassword = async (body) => {
    const response = await RequestManager.put({
        url: "/me/resetPassword/v1/",
        handleUnauthorizedResponse: false,
        body
    });
    return response;
};

const Me = {
    resetPassword
};

export default Me;
